import React from "react";
import { IconButton, Stack, Tooltip } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import { FormattedMessage, useIntl } from "react-intl";
import { useSnackbar } from "notistack";

import { handleCopyClick, handleLinkedinShare } from "bundles/common/utils/utils";

const shareIconButtonSx = (theme) => ({
  bgcolor: "#CEE1DA",
  color: theme.palette.primary.main,
  width: 32,
  height: 32,
  boxShadow: "none",
  "&:hover": {
    bgcolor: "#B8D4CB",
    boxShadow: "none",
  },
  "& .MuiSvgIcon-root": {
    fontSize: 18,
  },
});

const publicShareIconButtonSx = {
  width: 32,
  height: 32,
  minWidth: 32,
  borderRadius: "7px",
  border: "1px solid #000",
  bgcolor: "#fff",
  color: "#000",
  p: 0.5,
  boxShadow: "none",
  "&:hover": {
    bgcolor: "#fff",
    opacity: 0.8,
    boxShadow: "none",
  },
  "& .MuiSvgIcon-root": {
    fontSize: 18,
  },
};

const JobOfferShareButtons = ({
  publicJobUrl,
  jobTitle = "",
  justifyContent = "flex-end",
  variant = "dashboard",
  sx,
}) => {
  const theme = useTheme();
  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();
  const shareSx = variant === "public" ? publicShareIconButtonSx : shareIconButtonSx(theme);

  const handleFacebookShare = () => {
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(publicJobUrl)}`,
      "_blank",
      "noopener,noreferrer,width=650,height=560"
    );
  };

  const handleEmailShare = () => {
    const subject = encodeURIComponent(jobTitle);
    const body = encodeURIComponent(publicJobUrl);
    window.location.href = `mailto:?subject=${subject}&body=${body}`;
  };

  return (
    <Stack
      direction="row"
      flexWrap="wrap"
      gap={0.75}
      justifyContent={justifyContent}
      sx={sx}
    >
      <Tooltip title={<FormattedMessage id="recruiter.dashboard.jobs.share_linkedin" />}>
        <IconButton size="small" onClick={() => handleLinkedinShare(publicJobUrl)} sx={shareSx}>
          <LinkedInIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title={<FormattedMessage id="recruiter.dashboard.jobs.share_facebook" />}>
        <IconButton size="small" onClick={handleFacebookShare} sx={shareSx}>
          <FacebookIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title={<FormattedMessage id="recruiter.dashboard.jobs.share_email" />}>
        <IconButton size="small" onClick={handleEmailShare} sx={shareSx}>
          <EmailOutlinedIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title={<FormattedMessage id="recruiter.dashboard.jobs.share_copy_url" />}>
        <IconButton
          size="small"
          onClick={() => handleCopyClick(publicJobUrl, intl, enqueueSnackbar)}
          sx={shareSx}
        >
          <ContentCopyOutlinedIcon />
        </IconButton>
      </Tooltip>
    </Stack>
  );
};

export default JobOfferShareButtons;
